import React from 'react';
import { vehicle } from '../../../../common/svg';
import SecureImage from "../../../../components/BucketImage/Image";

const TransportTracker: React.FC = () => {
  return (
    <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 max-w-screen-2xl mx-auto">
      <div className="flex flex-col items-center w-full">
        {/* Progress Bar */}
        <div className="relative flex items-center w-full h-[1rem] mt-4">
          {/* Start Point */}
          <div className="w-2 h-2 bg-green-500 border-2 border-green-500 rounded-full z-10"></div>

          {/* Solid Line */}
          <div className="flex-1 h-[0.12rem] bg-green-500"></div>

          {/* Truck Icon */}
          <div className="absolute flex flex-col items-center -top-[2.5rem] left-1/2 transform -translate-x-1/2">
            <SecureImage
              fileKey={vehicle}
              alt="vehicle"
              width="80px"
            />
          </div>

          {/* Dashed Line */}
          <div className="flex-1 h-[0.12rem] border-t-2 border-dashed border-[#444FBD]"></div>

          {/* Tooltip */}
          <div className="bg-[#444FBD] text-white text-xs px-3 py-1 rounded-[10px] absolute -top-16 right-0 w-max text-center">
            <div>Kms: 15 Km</div>
            <div>ETA: 1 hr 10 min</div>
            <div className="absolute bottom-[-5px] left-1/2 transform -translate-x-1/2 w-3 h-3 rotate-45 bg-[#444FBD]"></div>
          </div>

          {/* End Point */}
          <div className="w-2 h-2 bg-[#444FBD] border-2 border-[#444FBD] rounded-full z-10"></div>
        </div>

        {/* Labels */}
        <div className="flex justify-between w-full mt-3 text-center">
          <div className="flex flex-col items-center w-1/2">
            <div className="text-[14px] text-[#7E7E7E] font-[400]">Loading Point</div>
          </div>
          <div className="flex flex-col items-center w-1/2">
            <div className="text-[14px] text-[#7E7E7E] font-[400]">Clearance Point</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransportTracker;
